import React, { ReactNode } from "react"
import { createPortal } from "react-dom"
import { isBrowser } from "../../utils"
import * as styles from "./InfoTooltip.module.scss"

export type InfoTooltipProps = { text: ReactNode }

const InfoTooltip: React.FC<InfoTooltipProps> = props => {
  //console.log('Rendering InfoTooltip', props)
  const [pos, setPos] = React.useState({ top: 0, left: 0 })
  const [visible, setVisible] = React.useState(false)
  const cont = React.useRef<HTMLSpanElement>(null)
  let iv: number
  React.useEffect(() => {
    const update = () => {
      const rect = cont.current?.getBoundingClientRect()
      if (rect && pos.top !== rect.top) setPos(rect)
    }

    // tarkistetaan sijainti puolen sekunnin välein...
    iv = window.setInterval(update, 500)

    return () => {
      clearInterval(iv)
    }
  }, [])

  if (!isBrowser || !props.text) return null

  return (
    <span ref={cont} className={styles.info} onPointerEnter={() => setVisible(true)}>
      i
      {visible &&
        createPortal(
          <div
            onPointerLeave={() => setVisible(false)}
            className={styles.tooltip}
            style={{ top: pos.top + 20, left: Math.min(pos.left, window.innerWidth - 250) }}>
            <div className={styles.content}>{props.text}</div>
          </div>,
          document.body
        )}
    </span>
  )
}

export default InfoTooltip
